module.exports={
  "Description": "2-Digits - NN",
  "RedundantCharacters": " -",
  "ValidationRegex": "^[0-9]{2}$",
  "TestData": {
    "Valid": [
      "12",
      "56"
    ],
    "Invalid": [
      "012",
      "1s",
      "1",
      "x3"
    ]
  }
}
